export default __webpack_public_path__ + "static/media/path1.ebc1ffd7.svg";